export function stripLegacyAddressCoordinates<T extends { address?: any }>(values: T): T {
  if (!values.address || typeof values.address !== 'object') {
    return values;
  }

  const { coordinates: _legacyCoordinates, ...address } = values.address;
  return {
    ...values,
    address,
  };
}
